import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions, combineActions } from 'redux-actions';
import { reduxKey, defaultState } from './constants';
import { enterZoomMode, exitZoomMode, showPanel, hidePanel, hidePanelPopup, setScreenSize, fetchRelatedContentForDeviation, fetchRelatedContentError, fetchRelatedContentSuccess } from './actions';
import { setViewMode } from '../../publicSession/actions';
import { unloadDuperbrowseItem, exitDuperbrowseDone } from '../../Duperbrowse/redux/actionCreators';
import { getDeviationEntityId } from '../../redux/normalizr/schemas/deviation';
const actionHandlers = handleActions({
    [setViewMode.toString()]: (state, { payload: { nextViewMode, currentViewMode } })=>_object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                isInZoom: nextViewMode !== currentViewMode ? false : state.viewOptions.isInZoom
            })
        }),
    [enterZoomMode.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                isInZoom: true
            })
        }),
    [exitZoomMode.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                isInZoom: false
            })
        }),
    [showPanel.toString()]: (state, { payload: { actionBar = 'primary', panelType } })=>_object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                visiblePanel: panelType,
                activeActionBar: actionBar
            })
        }),
    [hidePanel.toString()]: (state, { payload: { panelType } })=>state.viewOptions.visiblePanel === panelType ? _object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                visiblePanel: false,
                activeActionBar: 'primary'
            })
        }) : state,
    [combineActions(unloadDuperbrowseItem, exitDuperbrowseDone).toString()]: (state)=>state.viewOptions.visiblePanel ? _object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                visiblePanel: false,
                activeActionBar: 'primary',
                isInZoom: false
            })
        }) : _object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                isInZoom: false
            })
        }),
    [hidePanelPopup.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                visiblePanel: false,
                activeActionBar: 'primary'
            })
        }),
    [setScreenSize.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            viewOptions: _object_spread_props(_object_spread({}, state.viewOptions), {
                screenSize: action.payload
            })
        }),
    [fetchRelatedContentForDeviation.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            secondaryContentLoaderState: _object_spread_props(_object_spread({}, state.secondaryContentLoaderState), {
                relatedContent: {
                    [getDeviationEntityId(action.payload.deviation)]: {
                        state: 'fetching'
                    }
                }
            })
        }),
    [fetchRelatedContentError.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            secondaryContentLoaderState: _object_spread_props(_object_spread({}, state.secondaryContentLoaderState), {
                relatedContent: {
                    [getDeviationEntityId(action.payload.deviation)]: {
                        state: 'error',
                        error: action.payload.err
                    }
                }
            })
        }),
    [fetchRelatedContentSuccess.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            secondaryContentLoaderState: _object_spread_props(_object_spread({}, state.secondaryContentLoaderState), {
                relatedContent: {
                    [getDeviationEntityId(action.payload.deviation)]: {
                        state: 'idle',
                        error: undefined
                    }
                }
            })
        })
}, defaultState);
export default {
    [reduxKey]: actionHandlers
};
